export { default } from './ContentAnswers';
